import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/animated-tabs'
import Templates from './(tabs)/templates'
import Overview from './(tabs)/overview'

const ReportsPage = () => {
  return (
    <div className='p-4 space-y-4 h-full flex flex-col justify-between overflow-auto'>
      <header>
        <h1 className='text-3xl font-bold'>Rapporten</h1>
      </header>

      <Tabs className="h-full overflow-auto" defaultValue='templates'>
        <div className='flex flex-col justify-between h-full'>
            <TabsList>
                {/* <TabsTrigger value='overview'>Overzicht</TabsTrigger> */}
                <TabsTrigger value='templates'>Sjablonen</TabsTrigger>
            </TabsList>

            <TabsContent value='overview' className='overflow-auto h-full'>
                <Overview />
            </TabsContent>

            <TabsContent value='templates' className='overflow-auto h-full'>
                <Templates />
            </TabsContent>
        </div>
      </Tabs>
    </div>
  )
}

export default ReportsPage